export { useSpotlightEffect } from './spotlight-effect'
